import { styled } from "@mui/material/styles";
import SwipeableViews from "react-swipeable-views";

const TabPanelContainer = styled(SwipeableViews)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.up("md")]: {
    paddingTop: "16px",
  },

  "& .react-swipeable-view-container ": {
    flex: 1,
  },

  [`& .react-swipeable-view-container > div`]: {
    overflow: "visible !important",
  },
}));

export { TabPanelContainer };
